
import {
	RECEIVE_ARTISTS,
	RECEIVE_WORKS
} from 'actions/WorksActions';

export default function readyReducer(state=false, action){

	switch(action.type){
		case RECEIVE_WORKS:
			return true;
		default:
			return state;
	}
	
}